module.exports = __webpack_public_path__ + "img/icon_change_language.079a4191.svg";